import React, { useContext } from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { useMatch, useNavigate } from 'react-router-dom'
import { Box, Button, Illustration } from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import { contactAtom } from 'pages/Contacts/atoms/contactAtoms'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { paymentAtom } from './atoms/atoms'

export const SendComplete = () => {
  const { t } = useTranslation()
  const paymentUrl = `${PathNames.PAYMENTS}${PathNames.CRYPTO}`
  const match = useMatch(paymentUrl)
  const [walletAction] = useContext(WalletActionContext)
  const payment = useAtomValue(paymentAtom)
  const contact = useAtomValue(contactAtom)
  const navigate = useNavigate()

  const handleNavigateClick = async () => {
    if (match) {
      walletAction?.meta?.onPayoutSuccess()
      walletAction?.onClose()
    } else {
      navigate(`${PathNames.PAYMENTS}${PathNames.CRYPTO}`)
    }
  }

  return (
    <Box
      flex
      flexCol
      justify="center"
      align="center"
      className="max-w-[500px] gap-5 text-center"
      data-testId="complete-success"
    >
      <Illustration name="HandsClapping" color="success" />
      <h1 className="text-foreground-prominent text-h1">
        {t('wallets.send.completeSuccess', {
          fromCurrencyAmounts: `${payment?.walletCurrency?.amount} ${payment?.walletCurrency?.currency}`,
          toCurrencyAmounts: `${payment?.paidCurrency?.amount} ${payment?.paidCurrency?.currency}`,
          contactName: contact?.name,
        })}
      </h1>
      <Button data-testId="transaction-history" onClick={handleNavigateClick}>
        {t('wallets.send.goToPayments')}
      </Button>
    </Box>
  )
}
